(function() {
  // --- UTILITY: Debounce Function ---
  // Prevents functions from firing dozens of times per second during DOM updates.
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // --- MODULE 1: Seal Subscriptions ---
  function initSealModifications() {
    const container = document.querySelector('.sealsubs-container');
    if (!container) return false;

    // 1A. Enhance Cards (Prices & Annotations)
    function applyEnhancements() {
      const otContainer = container.querySelector('.sls-option-container[role="button"]');
      if (!otContainer) return;
      
      const otMoneyEl = otContainer.querySelector('.sls-one-time-price .money, .sls-price .money');
      if (!otMoneyEl) return;
      
      const rawPrice = otMoneyEl.textContent.trim();
      const numericPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, ''));
      if (isNaN(numericPrice) || numericPrice === 0) return;
      
      const currencySymbol = rawPrice.replace(/[0-9,.\s]/g, '').charAt(0) || '$';
      const servings = 30;
      
      const fmt = (n) => currencySymbol + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      
      const addAnn = (el, id, html) => {
        if (el.querySelector('.seal-ann-' + id)) return; // Skip if already exists
        const div = document.createElement('div');
        div.className = `seal-ann seal-ann-${id}`;
        div.innerHTML = html;
        el.appendChild(div);
      };
      
      // 30-DAY
      const day30 = container.querySelector('.sls-option-container[data-selling-plan-group="0"]');
      if (day30) {
        addAnn(day30, '30', `<span class="seal-ps">${fmt((numericPrice * 0.80) / servings)}/serving</span>`);
      }
      
      // 90-DAY
      const day90 = container.querySelector('.sls-option-container[data-selling-plan-group="1"]');
      if (day90 && !day90.querySelector('#seal-custom-price-90')) {
        const mp90 = numericPrice * 0.70;
        const customPrice = document.createElement('div');
        customPrice.id = 'seal-custom-price-90';
        customPrice.className = 'seal-custom-price';
        customPrice.innerHTML = 
          `<span class="seal-cp-strikethrough">${fmt(numericPrice)}</span>
           <span class="seal-cp-main">${fmt(mp90)}<span class="seal-cp-mo">/mo</span></span>`;
        
        const firstLine = day90.querySelector('.sls-label-container > .sls-selling-plan-group-first-line');
        if (firstLine) firstLine.appendChild(customPrice);
        
        addAnn(day90, '90',
          `<span class="seal-ps">${fmt(mp90 / servings)}/serving</span>
           <span class="seal-tb">${fmt(mp90 * 3)} billed every 3 months</span>`
        );
      }
    }

    // 1B. Fix One-Time Click Issue
    function applyClickFix() {
      if (container.dataset.otFixed) return;
      
      const form = document.querySelector('form[action*="/cart/add"], product-form form, .product-form__buttons form') || document.querySelector('product-form');
      const actualForm = (form && form.tagName !== 'FORM') ? (form.querySelector('form') || form.closest('form')) : form;
      const oneTimeOption = container.querySelector('.sls-option-container[role="button"]');
      
      if (!actualForm || !oneTimeOption) return;
      
      let blockSubmit = false;
      oneTimeOption.addEventListener('click', () => {
        blockSubmit = true;
        setTimeout(() => { blockSubmit = false; }, 500);
      });
      
      actualForm.addEventListener('submit', (e) => {
        if (blockSubmit) {
          e.preventDefault();
          e.stopImmediatePropagation();
          blockSubmit = false;
        }
      }, true);
      
      container.dataset.otFixed = 'true';
    }

    // Initialize Seal enhancements
    applyEnhancements();
    applyClickFix();

    // Observe Seal container for re-renders (Debounced for performance)
    const sealObserver = new MutationObserver(debounce(() => {
      applyEnhancements();
    }, 150));
    sealObserver.observe(container, { childList: true, subtree: true });

    return true;
  }

  // --- MODULE 2: Compact Free Gifts ---
  function compactFreeGifts() {
    const items = document.querySelectorAll('#CartDrawer .horizontal-product:not(.cart-free-gift), #CartDrawer [id*="CartDrawer-Item"]:not(.cart-free-gift), .section-main-cart .cart-item:not(.cart-free-gift)');
    
    items.forEach(item => {
      let isGift = false;
      const itemText = (item.textContent || '').toLowerCase();
      
      // Fast check: look for $0.00, 100% off, free, or gift
      if (itemText.includes('$0.00') || itemText.includes('100% off') || itemText.includes('free') || itemText.includes('gift')) {
        // Verify against actual price elements to avoid false positives
        const prices = Array.from(item.querySelectorAll('.price span, .price')).map(p => p.textContent.trim());
        if (prices.some(p => /^\$0\.(00)?$/.test(p) || p === '0.00' || p === '$0.00') || itemText.includes('100% off')) {
          isGift = true;
        }
      }
      
      if (isGift) item.classList.add('cart-free-gift');
    });
  }

  function initCartObserver() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;

    // Observe ONLY the cart drawer, and debounce the execution (wait 150ms after DOM settles)
    const cartObserver = new MutationObserver(debounce(() => {
      compactFreeGifts();
    }, 150));
    cartObserver.observe(drawer, { childList: true, subtree: true });

    compactFreeGifts(); // Run initial pass
    return true;
  }

  // --- BOOTSTRAPPER: Unified Polling ---
  // Replaces the multiple overlapping setIntervals
  let attempts = 0;
  let sealLoaded = false;
  let cartLoaded = false;

  const bootstrapper = setInterval(() => {
    attempts++;
    
    if (!sealLoaded) sealLoaded = initSealModifications();
    if (!cartLoaded) cartLoaded = initCartObserver();

    // Stop checking once both are found, or after 60 attempts (~15 seconds)
    if ((sealLoaded && cartLoaded) || attempts > 60) {
      clearInterval(bootstrapper);
      // Fallback: run free gifts one last time in case it's a dedicated cart page (no drawer)
      if (!cartLoaded) compactFreeGifts(); 
    }
  }, 250);

})();